export const resolveColorDtoToCss = (
  colorOne?: string,
  colorTwo?: string,
  gradientDirection?: string
): string => {
  if (!colorOne) {
    return 'transparent';
  }
  if (!colorTwo) {
    return colorOne;
  }
  const direction = gradientDirection || 'to bottom';
  return `linear-gradient(${direction}, ${colorOne}, ${colorTwo})`;
};
